import { MutationHookOptions, useMutation } from '@apollo/client';
import sendDOIConfirmEmail from '../../graphql/sendDOIConfirmEmail';

export interface SendDOIConfirmEmail {
  sendDOIConfirmEmail: boolean;
}

const useSendDOIConfirmEmail = (options?: MutationHookOptions<SendDOIConfirmEmail>) =>
  useMutation<SendDOIConfirmEmail>(sendDOIConfirmEmail, options);

export default useSendDOIConfirmEmail;
